/* =========================================================
   Hero Launch + Form — JS
   - Submit AJAX direto pra RD Station Marketing API (API Key)
   - Sem reload de página
   - Substitui form pela view de sucesso
   - opt-in (legal_bases) enviado automático como granted
   - Bloqueia tracker do RD para evitar conversão duplicada
   - Captura e envia telefone/WhatsApp (mobile_phone)
   ========================================================= */
(function () {
  'use strict';

  var RD_API_URL = 'https://api.rd.services/platform/conversions';

  function initSection(section) {
    if (!section || section.dataset.hlfInit === 'true') return;
    section.dataset.hlfInit = 'true';

    /* ---------- Fade-in do glass ---------- */
    var animatedEls = section.querySelectorAll('[data-hlf-animate]');

    if ('IntersectionObserver' in window && animatedEls.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.05, rootMargin: '0px' }
      );
      animatedEls.forEach(function (el) { observer.observe(el); });
    } else {
      animatedEls.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ---------- Pause vídeo quando aba não visível ---------- */
    var video = section.querySelector('.hlf-hero__video');
    if (video) {
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          video.pause();
        } else {
          var p = video.play();
          if (p !== undefined) p.catch(function () {});
        }
      });
    }

    /* ---------- Submit do form ---------- */
    var form = section.querySelector('[data-hlf-form]');
    if (!form) return;

    /* Marca o form para que o tracker global do RD ignore
       (o RD respeita o atributo data-rdstation-form="false"
       e também a classe rd-no-track) */
    form.setAttribute('data-rdstation-form', 'false');
    form.classList.add('rd-no-track');

    var formView = section.querySelector('[data-hlf-view="form"]');
    var successView = section.querySelector('[data-hlf-view="success"]');
    var errorsBox = section.querySelector('[data-hlf-form-errors]');
    var cta = section.querySelector('[data-hlf-cta]');
    var ctaLabel = section.querySelector('[data-hlf-cta-label]');

    var apiKey = section.dataset.rdApiKey;
    var conversionIdentifier = section.dataset.rdConversionIdentifier || 'pre-lancamento';
    var rawTags = section.dataset.rdTags || '';
    var tags = rawTags
      .split(',')
      .map(function (t) { return t.trim(); })
      .filter(function (t) { return t.length > 0; });

    function showError(message) {
      if (!errorsBox) return;
      errorsBox.textContent = message;
      errorsBox.hidden = false;
    }

    function clearError() {
      if (!errorsBox) return;
      errorsBox.textContent = '';
      errorsBox.hidden = true;
    }

    function setLoading(isLoading) {
      if (!cta) return;
      cta.disabled = isLoading;
      if (isLoading) {
        cta.classList.add('is-loading');
        if (ctaLabel) {
          cta.dataset.originalLabel = ctaLabel.textContent;
          ctaLabel.textContent = 'Enviando...';
        }
      } else {
        cta.classList.remove('is-loading');
        if (ctaLabel && cta.dataset.originalLabel) {
          ctaLabel.textContent = cta.dataset.originalLabel;
        }
      }
    }

    function showSuccess() {
      if (!formView || !successView) return;

      formView.classList.add('is-leaving');

      window.setTimeout(function () {
        formView.hidden = true;
        successView.hidden = false;

        var glass = section.querySelector('.hlf-glass');
        if (glass) {
          var rect = glass.getBoundingClientRect();
          if (rect.top < 0 || rect.bottom > window.innerHeight) {
            glass.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }, 350);
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    /* Extrai só os dígitos do telefone, sem código de país nem zeros à esquerda.
       Retorna '' se não houver dígitos. */
    function phoneDigits(value) {
      var digits = (value || '').replace(/\D/g, '').replace(/^0+/, '');
      // remove o código do país (55) se o usuário digitou
      if ((digits.length === 12 || digits.length === 13) && digits.indexOf('55') === 0) {
        digits = digits.slice(2);
      }
      return digits;
    }

    /* Válido = telefone fixo (10 dígitos) ou celular/WhatsApp (11 dígitos), com DDD. */
    function isValidPhone(value) {
      var digits = phoneDigits(value);
      return digits.length === 10 || digits.length === 11;
    }

    /* Normaliza para o formato E.164 esperado pelo RD Station: +55DDDNÚMERO. */
    function normalizePhone(value) {
      var digits = phoneDigits(value);
      if (!digits) return '';
      return '+55' + digits;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImpropagation && e.stopImpropagation();
      clearError();

      var name = (form.querySelector('[name="name"]') || {}).value || '';
      var email = (form.querySelector('[name="email"]') || {}).value || '';
      var phone = (form.querySelector('[name="mobile_phone"]') || {}).value || '';
      name = name.trim();
      email = email.trim();
      phone = phone.trim();

      // Validação
      if (!name) {
        showError('Por favor, informe seu nome.');
        return;
      }
      if (!email || !isValidEmail(email)) {
        showError('Por favor, informe um e-mail válido.');
        return;
      }
      if (!isValidPhone(phone)) {
        showError('Por favor, informe um WhatsApp válido com DDD.');
        return;
      }
      if (!apiKey) {
        showError('Configuração inválida. Contate o suporte.');
        // eslint-disable-next-line no-console
        console.error('[hero-launch-form] RD Station API Key não configurada no customizer.');
        return;
      }

      setLoading(true);

      var payload = {
        event_type: 'CONVERSION',
        event_family: 'CDP',
        payload: {
          conversion_identifier: conversionIdentifier,
          name: name,
          email: email,
          mobile_phone: normalizePhone(phone),
          tags: tags,
          available_for_mailing: true,
          legal_bases: [
            {
              category: 'communications',
              type: 'consent',
              status: 'granted'
            }
          ],
          traffic_source: document.referrer || ''
        }
      };

      var endpoint = RD_API_URL + '?api_key=' + encodeURIComponent(apiKey);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            return null;
          }
          return response.json().then(function (data) {
            throw new Error(
              (data && data.errors && JSON.stringify(data.errors)) ||
              'Erro ao enviar (status ' + response.status + ')'
            );
          }).catch(function () {
            throw new Error('Erro ao enviar (status ' + response.status + ')');
          });
        })
        .then(function () {
          // dataLayer / GA event (opcional)
          if (window.dataLayer && typeof window.dataLayer.push === 'function') {
            window.dataLayer.push({
              event: 'rd_conversion',
              conversion_identifier: conversionIdentifier
            });
          }
          showSuccess();
        })
        .catch(function (err) {
          // eslint-disable-next-line no-console
          console.error('[hero-launch-form] Erro RD Station:', err);
          setLoading(false);
          showError('Não foi possível enviar agora. Tente novamente em instantes.');
        });
    }, true); // useCapture = true: capturamos o evento ANTES do tracker do RD
  }

  function initAll() {
    document.querySelectorAll('.hlf-hero').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Compatibilidade com Shopify Theme Editor */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.hlf-hero');
    if (section) initSection(section);
  });
})();